import { isPlatformBrowser } from '@angular/common';
import { ElementRef, inject, Injectable, PLATFORM_ID } from '@angular/core';
import { WindowRef } from '@spartacus/core';

export interface ScrollToOptions {
  offset?: number;
  behavior?: ScrollBehavior;
}

@Injectable({
  providedIn: 'root',
})
export class ScrollToService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly windowRef = inject(WindowRef);

  scrollToElement(target: HTMLElement | ElementRef<HTMLElement>, options: ScrollToOptions = {}): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const nativeWindow = this.windowRef.nativeWindow;
    const element = target instanceof ElementRef ? target.nativeElement : target;

    if (!element || !nativeWindow) {
      return;
    }

    const { offset = 0, behavior = 'smooth' } = options;

    const top = element.getBoundingClientRect().top + nativeWindow.scrollY + offset;

    nativeWindow.scrollTo({
      top: Math.max(0, top),
      behavior,
    });
  }

  scrollToId(id: string, options: ScrollToOptions = {}): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const element = this.windowRef.document?.getElementById(id);

    if (!element) {
      return;
    }

    this.scrollToElement(element, options);
  }

  scrollToTop(options: ScrollToOptions = {}): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const nativeWindow = this.windowRef.nativeWindow;

    if (!nativeWindow) {
      return;
    }

    const { offset = 0, behavior = 'smooth' } = options;

    nativeWindow.scrollTo({
      top: Math.max(0, offset),
      behavior,
    });
  }
}
